<template>
  <el-dialog :visible.sync="visibleSync"
             :title="dialogTitle"
             width="70%"
             top="2vh"
             :append-to-body="true"
             destroy-on-close
             custom-class="project-node-audit-dialog"
             @close="handleAuditClose">
    <!-- 动态组件：根据 nodeKey 渲染不同组件 -->
    <component :is="currentAuditComponent"
               v-if="currentAuditComponent"
               :visible.sync="visibleSync"
               :project-id="projectId"
               :fullNode="fullNode"
               @refreshDetail="$emit('refreshDetail')"/>
    <!-- 无对应组件时的默认展示 -->
    <div v-else
         class="no-view-component">
      <i class="el-icon-info"></i>
      <p>该节点暂无审批组件</p>
      <p class="node-key">key: {{ nodeKey }}</p>
    </div>
  </el-dialog>
</template>

<script>
import projectMixins from '@views/project/project.mixins'
import ProjectCostAuditDialog from '@views/project/node-audit/ProjectCostAuditDialog.vue'

export default {
  mixins: [projectMixins],
  components: {
    ProjectCostAuditDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [String, Number],
      default: ''
    },
    fullNode: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visibleSync: false
    }
  },
  computed: {
    // 节点 key
    nodeKey () {
      return this.fullNode.key || ''
    },
    // 当前应渲染的组件
    currentAuditComponent () {
      if (!this.nodeKey || !this.projectProgressNodeMap) return null
      return this.projectProgressNodeMap[this.nodeKey].nodeAuditComponent || null
    },
    // 弹窗标题
    dialogTitle () {
      const nodeName = this.fullNode.name || '项目节点'
      return `${nodeName} - 审批`
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.visibleSync = val
      },
      immediate: true
    },
    visibleSync (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleAuditClose () {
      this.visibleSync = false
      this.$emit('refreshDetail')
    }
  }
}
</script>

<style lang="scss">
.project-node-audit-dialog {
  min-height: 80vh !important;
  max-height: 95vh !important;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
    background: #f8fafc;
    flex-shrink: 0;
  }

  .el-dialog__body {
    padding: 24px;
    flex: 1;
    overflow-y: auto;
  }
}
</style>

<style lang="scss"
       scoped>
.no-view-component {
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;

  i {
    font-size: 48px;
    color: #cbd5e1;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    margin: 8px 0;
  }

  .node-key {
    font-size: 12px;
    color: #64748b;
    font-family: monospace;
    background: #f1f5f9;
    padding: 4px 12px;
    border-radius: 4px;
    display: inline-block;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/pages/ProjectNodeAudit.vue